export default "__VITE_ASSET__DtkM0ZLt__"